import React, { useEffect, useMemo, useState } from "react";
import { createPortal } from "react-dom";
import { sortSymbolsWithPinned } from "./symbolListUtils";

/**
 * 심볼 목록만 필요합니다. /SetPage/user 는 members_data.uuid 기준이라
 * 관리자 로그인 쿠키(super_user 세션 uuid)와 맞지 않아 오탐으로 로그아웃될 수 있어 호출하지 않습니다.
 */
export default function SymbolSearchPopup({ isOpen, onAdd, onClose, anchorPosition }) {
    const [totalsymbolList, setTotalSymbolList] = useState([]);

    useEffect(() => {
      fetch('/bitget_symbols')
        .then((res) => res.json())
        .then((data) => {
          setTotalSymbolList(data.symbols || []);
        })
        .catch((err) => console.error('비트겟 심볼 불러오기 실패:', err));
    }, []);

    const [searchTerm, setSearchTerm] = useState("");
    const filteredList = useMemo(
      () => sortSymbolsWithPinned(totalsymbolList, searchTerm),
      [totalsymbolList, searchTerm]
    );

    if (!isOpen) return null;

    const isInline = Boolean(anchorPosition);
    const backdropClass = isInline ? 'popup-inline' : 'popup-backdrop';
    const backdropStyle = isInline
      ? {
          '--popup-top': `${anchorPosition.top}px`,
          '--popup-left': `${anchorPosition.left}px`,
        }
      : undefined;

    const popupTree = (
      <div
        className={backdropClass}
        style={backdropStyle}
        onClick={() => {
          if (!isInline) {
            onClose();
          }
        }}
      >
        <div className="popup" onClick={(e) => e.stopPropagation()}>
          <h3>심볼 검색/선택</h3>
          <input
            type="text"
            placeholder="심볼을 입력하세요"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-input"
          />
          <ul className="suggestion-list">
            {!searchTerm.trim() ? (
              <li className="symbol-search-popup__pinned-label" aria-hidden="true">
                주요 코인 (BTC · ETH · XRP · SOL · ETC · BCH)
              </li>
            ) : null}
            {filteredList.map((symbol) => (
              <li
                key={symbol}
                className="suggestion-item"
                onClick={() => {
                  onAdd(symbol);
                  setSearchTerm("");
                }}
              >
                {symbol}
              </li>
            ))}
          </ul>
          <button type="button" onClick={onClose} className="close-button">
            닫기
          </button>
        </div>
      </div>
    );

    return createPortal(popupTree, document.body);
};
